module.exports = __webpack_public_path__ + "static/media/view10_bg1.fe7fc4b2.jpg";